import {prefersReducedMotion} from "./progress"

const HOSTED_ZONE = "your-inbound-zone"

function normaliseHost(value) {
  let host = String(value || "").trim().toLowerCase()
  host = host.replace(/^[a-z][a-z0-9+.-]*:\/\//, "")
  host = host.split("/")[0]
  host = host.split("?")[0]
  host = host.split("#")[0]
  host = host.replace(/:\d+$/, "")
  host = host.replace(/^\.+|\.+$/g, "")
  return host || "inbound.example.com"
}

function isBareOrg(host) {
  return host.split(".").filter(Boolean).length <= 2
}

function inboxType(root) {
  return root.querySelector("[data-learn-inbox][aria-pressed='true']")?.dataset.learnInbox || "domain"
}

function deliveryOf(root) {
  return root.querySelector("[data-learn-delivery][aria-pressed='true']")?.dataset.learnDelivery || "json"
}

function plusOn(root) {
  return root.querySelector("[data-learn-plus]")?.getAttribute("aria-pressed") === "true"
}

function mailbox(hosted, host, plus) {
  if (hosted) return plus ? `reply+ticket_123@${HOSTED_ZONE}` : `support-acme@${HOSTED_ZONE}`
  return plus ? `reply+ticket_123@${host}` : `support@${host}`
}

function jsonPayload(hosted, host, plus) {
  const to = mailbox(hosted, host, plus)
  return JSON.stringify({
    from: "ana@acme.example",
    to,
    subject: "Seat reset",
    text: "Please reset seat 12.",
    attachments: [],
    envelope: {
      mail_from: "ana@acme.example",
      rcpt_to: to,
      plus_tag: plus ? "ticket_123" : null
    }
  }, null, 2)
}

function payloadText(delivery, hosted, host, plus) {
  if (delivery === "parse") return "multipart/form-data with SendGrid Inbound Parse fields"
  if (delivery === "forward") return "Resigned and sent to an address on one of your sending domains."
  return jsonPayload(hosted, host, plus)
}

function playFlow(root) {
  const nodes = Array.from(root.querySelectorAll("[data-learn-node]"))
  if (prefersReducedMotion()) {
    nodes.forEach((node) => {
      node.style.opacity = "1"
    })
    return
  }
  nodes.forEach((node) => {
    node.style.opacity = "0.35"
  })
  nodes.forEach((node, index) => {
    window.setTimeout(() => {
      node.style.opacity = "1"
    }, index * 70)
  })
}

function setPressed(buttons, current) {
  buttons.forEach((button) => button.setAttribute("aria-pressed", String(button === current)))
}

function render(root, animate) {
  const hosted = inboxType(root) === "hosted"
  const delivery = deliveryOf(root)
  const plus = plusOn(root)
  const host = hosted ? HOSTED_ZONE : normaliseHost(root.querySelector("[data-learn-host]")?.value)
  const bound = root.querySelector("[data-learn-bound]")
  const hostedBox = root.querySelector("[data-learn-hosted]")
  if (bound) bound.hidden = hosted
  if (hostedBox) hostedBox.hidden = !hosted
  const mxHost = root.querySelector("[data-learn-mx-host]")
  if (mxHost) mxHost.textContent = host
  const warn = root.querySelector("[data-learn-mx-warn]")
  if (warn) warn.hidden = hosted || !isBareOrg(host)
  const mxNode = root.querySelector("[data-learn-node-mx]")
  if (mxNode) mxNode.textContent = hosted ? "Inbound zone" : "MX"
  const endNode = root.querySelector("[data-learn-node-end]")
  if (endNode) endNode.textContent = delivery === "forward" ? "Forward address" : "Your app"
  const payload = root.querySelector("[data-learn-payload]")
  if (payload) payload.textContent = payloadText(delivery, hosted, host, plus)
  const tip = root.querySelector("[data-learn-plus-tip]")
  const addr = root.querySelector("[data-learn-plus-addr]")
  if (tip) tip.hidden = !plus
  if (addr) addr.textContent = mailbox(hosted, host, true)
  if (animate) playFlow(root)
}

export function mount(root) {
  const inboxButtons = Array.from(root.querySelectorAll("[data-learn-inbox]"))
  inboxButtons.forEach((button) => {
    button.addEventListener("click", () => {
      setPressed(inboxButtons, button)
      render(root, true)
    })
  })
  const deliveryButtons = Array.from(root.querySelectorAll("[data-learn-delivery]"))
  deliveryButtons.forEach((button) => {
    button.addEventListener("click", () => {
      setPressed(deliveryButtons, button)
      render(root, true)
    })
  })
  const plus = root.querySelector("[data-learn-plus]")
  plus?.addEventListener("click", () => {
    plus.setAttribute("aria-pressed", String(plus.getAttribute("aria-pressed") !== "true"))
    render(root, false)
  })
  const hostInput = root.querySelector("[data-learn-host]")
  hostInput?.addEventListener("input", () => render(root, false))
  hostInput?.addEventListener("blur", () => {
    hostInput.value = normaliseHost(hostInput.value)
    render(root, false)
  })
  render(root, false)
}
